import React from 'react';

import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { getTableTextColor, getTableTitleColor } from 'apps/auth/helpers/historyUtils';

const CheckTableRow = (props) => {
    return (
        <TableRow
            title={props.title}
            titleColor={props.titleColor || getTableTitleColor(props.cheque)}
            textColor={props.textColor || getTableTextColor(props.cheque)}
        >
            {props.children}
        </TableRow>
    );
};

export default CheckTableRow;
